import { Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function TvIcon(props: IconProps) {
  const clipPathId = useId();
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <g clipPath={`url(#${clipPathId}-a)`}>
        <g
          clipPath={`url(#${clipPathId}-b)`}
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M16.6667 5.83301H3.33341c-.92047 0-1.66666.74619-1.66666 1.66666v9.16663c0 .9205.74619 1.6667 1.66666 1.6667H16.6667c.9205 0 1.6667-.7462 1.6667-1.6667V7.49967c0-.92047-.7462-1.66666-1.6667-1.66666Z" />
          <path d="M14.1666 1.66699 9.99992 5.83366 5.83325 1.66699" />
        </g>
      </g>
      <defs>
        <clipPath id={`${clipPathId}-a`}>
          <rect width="20" height="20" fill="#fff" />
        </clipPath>
        <clipPath id={`${clipPathId}-b`}>
          <rect width="20" height="20" fill="#fff" />
        </clipPath>
      </defs>
    </Icon>
  );
}
